import { render, staticRenderFns } from "./HistoryModal.vue?vue&type=template&id=28dab71e&"
import script from "./HistoryModal.vue?vue&type=script&lang=js&"
export * from "./HistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports